export default __webpack_public_path__ + "static/heron-f4e68412754138a41e27089c9cb99a0f.svg";